import styled from "styled-components/macro";
import { focusVisible, buttonReset } from "../../styles/a11y";

export const Container = styled.div`
  ${buttonReset}
  ${focusVisible}
  background-color: var(--menu-color);
  color: var(--grey-0);
  border-radius: 5px;
  border: 2px solid var(--grey-0);
  font-size: 16px;
  font-weight: 500;
  font-family: "Inter";
  display: flex;
  align-items: center;
  line-height: 1;
  width: 100%;
  text-align: left;

  &:focus-visible {
    border-color: var(--primary-cta);
  }

  &:disabled {
    background-color: var(--grey-3);
    cursor: not-allowed;
    opacity: 0.6;
  }

  .labels {
    flex-grow: 2;
    padding: 9px;

    .action-label {
      font-size: 16px;
      margin-bottom: 2px;
    }

    .mode-label {
      font-size: 9px;
    }
  }

  .submenu-control {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    padding-right: 12px;

    svg {
      display: block;
      width: 15px;
      height: 10px;
      path {
        fill: var(--grey-0);
      }
    }
  }
`;
